export const RESET = 'EXCMTASK_UPDATE_RESET'
export const SET_ERROR = 'EXCMTASK_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMTASK_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMTASK_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMTASK_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMTASK_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMTASK_UPDATE_UPDATE_RETRIEVED'
